module.exports = __webpack_public_path__ + "static/media/IP-Icon.2108ef1f.svg";